<template lang="pug">
Card.selections-card
    template(#header)
      .title {{ $t('selections.termsAgreement.title') }}
    template(#content)
      .text
        div(v-safe-html="$t('selections.termsAgreement.generalText')")
        p(v-if="showBerAgreement")
            span {{ $t('selections.termsAgreement.myBerText') }}
      SelectionsButtons.selector(:items="items" v-model="termsAccepted")

</template>
<script lang="ts">
import { useSettings } from "@/store";
import { useSelections } from "@/store/selections";
import { defineComponent } from "vue";
import { storeToRefs } from "pinia";
import Card from "primevue/card";
import SelectionsButtons from "@/components/forms/components/SelectionsButtons.vue";

export default defineComponent({
  name: "TermsAgreement",
  components: {
    Card,
    SelectionsButtons,
  },
  props: {
    showBerAgreement: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { termsAccepted } = storeToRefs(useSelections());
    const { settings } = storeToRefs(useSettings());

    const items = [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ];

    return {
      termsAccepted,
      settings,
      items,
    };
  },
});
</script>
<style scoped lang="scss">
.text {
  span {
    font-weight: bold;
    font-size: 1.1rem;
  }
}
.agreement-wrapper {
  padding: 2rem;
  display: flex;
  justify-content: space-between;
  .option {
    display: flex;
    align-items: center;
    width: 50%;
    label {
      margin-left: 1rem;
      font-size: 1.1rem;
    }
  }
}

.selector:deep(.form-control-radio-buttons) {
  padding: 2rem;
}
@media screen and (max-width: 720px) {
  .agreement-wrapper {
    padding: 0;
    margin-top: 2rem;
  }
}
</style>
